import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import logo from "../../assets/images/official.png";
import banner from "../../assets/images/banner.png"
import spin from "../../assets/spin.svg";
import { BiChevronLeft } from "react-icons/bi";
import { Input, message } from "antd";
import fetchDataTrace from "../../services/fetchDataTrace";
import postDataMail from "../../services/postDataMail";

export default function Forgot() {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [email, setEmail] = useState("");
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (email.trim()) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [email]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    const res = await fetchDataTrace({ uri: `users/email/${email}` });

    if (res?.success) {
      const name = `${res?.payload?.firstname}`;
      const data = {
        email,
        name,
        link: `https://roadside.toyota.co.tz/reset?token=${res?.payload?._id}&email=${email}&code=${res?.payload?.code}`,
      };
      const uri = `mail/password/reset`;
      const response = await postDataMail(data, uri);
      if (response?.success) {
        message.success("Email was sent successfully");
        setLoading(false);
        navigate("/");
      } else {
        message.error("Something went wrong");
        setLoading(false);
      }
      setLoading(false);
    } else {
      message.error("Sorry, Email does not exist");
      setLoading(false);
    }
  };

  const handleKeyPress = (e: any) => {
    if (e.keyCode === 13 || e.which === 13) {
      isButtonDisabled || handleSubmit(e);
    }
  };

  return (
    <div className="header min-h-screen bg-gray-200">
      <div className="bg-karimjee flex justify-center items-center">
        <img src={banner} alt="" className="w-28 aspect=[2/1]" />
      </div>

      <div className="flex justify-center">

        <div className="max-w-2xl w-full pt-12 sm:pt-12 px-5">
          <div className="flex flex-row justify-center">
            <div className="p-4 w-96 bg-white rounded-lg">
              <div className="text-center mt-4">
                <img className="mx-auto h-32 w-auto " src={logo} alt="" />
                <p>Enter your email to reset password </p>
              </div>
              <div className="mb-4">
                <form className="mt-2">
                  <input type="hidden" name="remember" value="true" />
                  <div className="rounded-md shadow-sm">
                    <div>
                      <Input
                        aria-label="Email"
                        name="email"
                        type="text"
                        size="large"
                        required
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyPress={(e) => handleKeyPress(e)}
                        className="flex flex-row justify-center"
                        placeholder="Email"
                      />
                    </div>
                  </div>

                  <Link
                    to="/"
                    className="text-xs text-center flex items-center text-karimjee hover:text-toyota mt-2 py-2 rounded-md"
                  >
                    <BiChevronLeft size={20} />
                    Go back
                  </Link>

                  <div className="border-t border-gray-300  max-w-md mt-4 mb-4 w-full"></div>

                  <div className="mt-4 mb-4">
                    <button
                      onClick={(e) => handleSubmit(e)}
                      className="group relative w-full flex justify-center py-3 sm:py-2 px-4
                        border border-transparent text-sm leading-5 font-medium
                        rounded-md text-white bg-toyota hover:bg-red-700
                        focus:outline-none focus:border-toyota
                        focus:shadow-outline-indigo active:bg-toyota transition
                        duration-150 ease-in-out"
                      style={{
                        background: "#e50000",
                        flexDirection: "row",
                        width: "100%",
                      }}
                    >
                      <span className="absolute left-0 inset-y-0 flex items-center pl-3"></span>

                      <span className="text-white">
                        {isLoading ? (
                          <div className="flex">
                            <img
                              src={spin}
                              alt="spin"
                              height="20px"
                              width="20px"
                            />{" "}
                            <span className="ml-1">Verifying Email</span>
                          </div>
                        ) : (
                          <span>Send Reset Password Link</span>
                        )}
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
